import PortalVue from 'portal-vue';
import Vue from 'vue';
import FlagIcon from 'vue-flag-icon';
import VueI18n from 'vue-i18n';
import VueMeta from 'vue-meta';
import VueMq from 'vue-mq';
import Router from 'vue-router';
import App from './App.vue';
// import i18n from './i18n';
import { defaultLocale, languages } from './locales';
import LunrClient from './model/LunrClient';
import vuetify from './plugins/vuetify';
import store from './store/store';
import IconUtil from './util/IconUtil';


Vue.use(VueI18n);
const messages = Object.assign(languages);


const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: defaultLocale,
  messages,
});
Vue.use(FlagIcon);

const router = new Router({
  routes: [{
    path: '/',
    redirect: '/de',
  }, {
    path: '/:lang',
    beforeEnter(to, from, next) {
      // eslint-disable-next-line
      const lang = to.params.lang;
      if (!Object.prototype.hasOwnProperty.call(messages, lang)) {
        // eslint-disable-next-line no-console
        console.warn(`route ${to.path} doesnt exist. routing to /de instead.`); return next('de');
      }
      if (i18n.locale !== lang) {
        i18n.locale = lang;
      }
      // add query to new route
      if (!Object.keys(to.query).length && Object.keys(from.query).length) {
        return next({ name: to.name, query: from.query });
      }
      return next();
    },
    children: [],
  }],
});

Vue.use(VueMeta, {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true,
});
Vue.use(VueMq, {
  breakpoints: {
    mobile: 450,
    tablet: 1250,
    desktop: Infinity,
  },
});
Vue.use(Router);
Vue.use(PortalVue);
Vue.config.productionTip = false;

/* For developers: in production build the config files will be loaded via the backend
 * If you are developing via Visual Studio Code and only in devlopment
 * mode the config files can be placed in /public/config
 */
const configFile = (process.env.NODE_ENV === 'production') ? 'rest/config/appconf?file=app-conf' : 'config/default/app-conf.json';
const imprintFile = (process.env.NODE_ENV === 'production') ? 'rest/config/appconf?file=imprint' : 'config/default/imprint.json';
const privacyFile = (process.env.NODE_ENV === 'production') ? 'rest/config/appconf?file=privacy' : 'config/default/privacy.json';
const mapboxStyle = (process.env.NODE_ENV === 'production') ? 'rest/config/appconf?file=style' : 'mapbox/style.json';

// Reading all needed data
const requestImprint = async () => {
  const response = await fetch(imprintFile);
  const json = await response.json();
  return json;
};

const requestPrivacy = async () => {
  const response = await fetch(privacyFile);
  const json = await response.json();
  return json;
};

const requestMapboxStyle = async () => {
  const response = await fetch(mapboxStyle);
  const json = await response.json();
  return json;
};

const requestVersion = async () => {
  if (process.env.NODE_ENV !== 'production') {
    return 'dev';
  }
  const response = await fetch('rest/data/version');
  const json = await response.json();
  return json;
};

// eslint-disable-next-line max-len
const requestFiles = async () => Promise.all([requestImprint(), requestPrivacy(), requestMapboxStyle(), requestVersion()]);


/* eslint-disable */
// eslint: do not use 'new' for side effects
requestFiles().then(([imprint, privacy, mapboxStyle, mapeditPortalVersion]) => {
  fetch(configFile)
  .then((response) => response.json())
  .then((appConfig) => {
    Vue.prototype.$appConfig = appConfig;
    Vue.prototype.$imprint = imprint;
    Vue.prototype.$privacy = privacy;
    Vue.prototype.$mapboxStyle = mapboxStyle;
    Vue.prototype.$lunr = new LunrClient(appConfig.lunrServerUrl);
    Vue.prototype.$icons = new IconUtil(appConfig.categories);
    Vue.prototype.$mapeditPortalVersion = mapeditPortalVersion;
    new Vue({
      router: router,
      el: '#app',
      i18n,
      vuetify,
      store,
      render: h => h(App)
    });
  });
});
/* eslint-enable */
